module.exports = __webpack_public_path__ + "img/poster_real-time-visibility.eaf4718a.png";